import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Form from "./Form/Form";
import List from "./List/List";

const USer = () => {
  const [id, setId] = useState(0);
  return (
    <div className="users">
      <Routes>
        <Route path="/" exact element={<List setId={setId} />} />
        <Route path="/new" exact element={<Form />} />
        <Route path="/edit/" exact element={<Form id={id} />} />
        <Route path="/*" exact element={<div>Erreur</div>} />
      </Routes>
    </div>
  );
};

export default USer;
